var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.routeExtras, function(extra, extraKey) {
        return [
          _vm.showExtra(extraKey)
            ? _c(
                "v-layout",
                { key: extraKey, attrs: { row: "", wrap: "" } },
                [
                  _c("v-list", { staticStyle: { width: "95%" } }, [
                    _c("div", { staticStyle: { padding: "0 0 0 10px" } }, [
                      _c(
                        "div",
                        { staticClass: "extra-bar" },
                        [
                          _vm._l(_vm.routeExtras[extraKey].summary, function(
                            summary,
                            index
                          ) {
                            return [
                              _c(
                                "v-tooltip",
                                {
                                  key: index + extraKey,
                                  attrs: {
                                    disabled: _vm.$lowResolution,
                                    top: ""
                                  }
                                },
                                [
                                  _c("div", {
                                    staticClass: "segment",
                                    style: _vm.segmentStyle(
                                      extraKey,
                                      summary,
                                      index
                                    ),
                                    attrs: { slot: "activator" },
                                    slot: "activator"
                                  }),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.getExtraValueLabel(
                                          extraKey,
                                          summary.value
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            ]
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "extra-bar-labels",
                          class: _vm.labelsOverflow ? "has-overflow" : "",
                          attrs: { id: "extra-bar-labels" + _vm.idx }
                        },
                        [
                          _vm._l(_vm.routeExtras[extraKey].summary, function(
                            summary,
                            index
                          ) {
                            return [
                              _c(
                                "div",
                                {
                                  key: "label-" + index + extraKey,
                                  staticClass: "segment-label",
                                  style: { "--seg-width": summary.amount + "%" }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.getExtraValueLabel(
                                          extraKey,
                                          summary.value
                                        )
                                      ) +
                                      " " +
                                      _vm._s(summary.amount.toFixed(1)) +
                                      " %\n              "
                                  )
                                ]
                              )
                            ]
                          })
                        ],
                        2
                      )
                    ])
                  ])
                ],
                1
              )
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-647f9bda", { render: render, staticRenderFns: staticRenderFns })
  }
}